import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import SkeletonPlaceholder from 'react-native-skeleton-placeholder';
import { DataTable } from 'react-native-paper';
import { useTheme } from '../../theme';
import { s, v } from '../../utils/libs';

type TableSkeletonProps = {
  columnWidths: number[];
  numRows?: number;
  rowHeight?: number;
};

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columnWidths,
  numRows = 8,
  rowHeight = v(60),
}) => {
  const { theme } = useTheme();
  const styles = useMemo(
    () => createStyles(theme, rowHeight),
    [theme, rowHeight],
  );

  const rows = Array.from({ length: Math.max(1, numRows) });

  return (
    <View>
      {rows.map((_, rowIdx) => (
        <DataTable.Row key={String(rowIdx)} style={styles.row}>
          {columnWidths.map((w, colIdx) => (
            <DataTable.Cell key={`${rowIdx}-${colIdx}`} style={{ width: w }}>
              <SkeletonPlaceholder
                backgroundColor={theme.colors.border}
                highlightColor={theme.colors.surfaceSecondary}>
                <SkeletonPlaceholder.Item
                  width={Math.max(40, w - s(32))}
                  height={v(16)}
                  borderRadius={s(6)}
                />
              </SkeletonPlaceholder>
            </DataTable.Cell>
          ))}
        </DataTable.Row>
      ))}
    </View>
  );
};

export default TableSkeleton;

const createStyles = (theme: any, rowHeight: number) =>
  StyleSheet.create({
    row: {
      minHeight: rowHeight,
      backgroundColor: theme.colors.surface,
    },
  });
